import { render, staticRenderFns } from "./ProductsCarouselEb.vue?vue&type=template&id=57030f84&name=article-products&"
import script from "./ProductsCarouselEb.vue?vue&type=script&lang=js&"
export * from "./ProductsCarouselEb.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCarouselEb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports